import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useAuth from "../../../hooks/useAuth";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TablePagination from "@mui/material/TablePagination";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";

import { deleteDistrict } from "../model/districts";

const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "rgba(243, 244, 251, 1)",
    color: "rgba(86, 99, 202, 1)",
    fontSize: "16px",
    fontWeight: "600",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    color: "rgba(19, 19, 19, 1)",
    border: 0,
  },
}));

const StyledTableRow = styled(TableRow)(() => ({
  "&:nth-of-type(odd)": { backgroundColor: "rgba(220, 222, 243, 0.1)" },
  "&:nth-of-type(even)": { backgroundColor: "rgba(220, 222, 243, 0.35)" },
}));
export default function TableDistricts({ districts }) {
  const dispatch = useDispatch();
  const { auth } = useAuth();
  const token = auth?.access_token;
  const [loadingIds, setLoadingIds] = useState({});

  const formattedDistricts =
    districts?.flatMap((district) =>
      district?.Districts.map((subDistrict) => ({
        ID: subDistrict.ID,
        parentName: district.name,
        districtName: subDistrict.name,
      })),
    ) || [];

  const [page, setPage] = useState(0);
  const rowsPerPage = 10;
  const handleChangePage = (_, newPage) => setPage(newPage);

  const handleDelete = (id) => {
    setLoadingIds((prev) => ({ ...prev, [id]: true }));
    dispatch(deleteDistrict({ id, token })).finally(() => {
      setLoadingIds((prev) => ({ ...prev, [id]: false }));
    });
  };

  return (
    <Paper sx={{ boxShadow: "none" }}>
      <TableContainer>
        <Table sx={{ minWidth: 700 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>Районы</StyledTableCell>
              <StyledTableCell>Микрорайоны</StyledTableCell>
              <StyledTableCell align="right">Действия</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {formattedDistricts.length === 0 ? (
              <StyledTableRow>
                <StyledTableCell colSpan={3} align="center">
                  Нет данных
                </StyledTableCell>
              </StyledTableRow>
            ) : (
              formattedDistricts
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((item, i) => (
                  <StyledTableRow key={i}>
                    <StyledTableCell>{item.parentName}</StyledTableCell>
                    <StyledTableCell>{item.districtName}</StyledTableCell>
                    <StyledTableCell>
                      <div
                        style={{
                          display: "flex",
                          gap: "5px",
                          justifyContent: "flex-end",
                        }}
                      >
                        {/* <button
                          style={{
                            backgroundColor: "rgba(220, 222, 243, 1)",
                            padding: 10,
                            borderRadius: 8,
                            cursor: "pointer",
                          }}
                        >
                          <ModeEditOutlineOutlinedIcon />
                        </button> */}

                        {loadingIds[item.ID] ? (
                          <div className="loader"></div>
                        ) : (
                          <button
                            onClick={() => handleDelete(item.ID)}
                            style={{
                              backgroundColor: "rgba(245, 212, 221, 1)",
                              padding: 10,
                              borderRadius: 8,
                              cursor: "pointer",
                            }}
                            disabled={loadingIds[item.ID]}
                          >
                            <DeleteOutlineOutlinedIcon />
                          </button>
                        )}
                      </div>
                    </StyledTableCell>
                  </StyledTableRow>
                ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {formattedDistricts.length > 0 && (
        <TablePagination
          rowsPerPageOptions={[]}
          component="div"
          count={formattedDistricts.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
        />
      )}
    </Paper>
  );
}
